import { apiCall } from "../helper/Common";

/**
 * Fetch the full analytics summary for the date range (and optional single bar).
 * @param {{ from?: string, to?: string, publicId?: string }} params
 */
export async function fetchAnalyticsSummary({ from, to, publicId } = {}) {
  const qs = new URLSearchParams();
  if (from) qs.set("from", from);
  if (to) qs.set("to", to);
  if (publicId) qs.set("public_id", publicId);
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  return apiCall(`analytics/summary${suffix}`, "GET");
}
